<template>
  <div class="d-flex flex-column fill-height">
    <v-overlay :value="isLoading" light>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <v-main id="content">
      <v-sheet class="mx-auto" max-width="1200">
        <div v-if="notFoundData">
          <v-alert type="warning" text border="left" class="mx-auto mt-12">
            {{ error || t("ERROR_PARAM_NOT_FOUND") }}
          </v-alert>
        </div>
        <div v-else>
          <div>
            <LanguageSwapper />
          </div>

          <div>
            <v-container>
              <v-row class="align-center">
                <v-col cols="12" md="4">
                  <div>
                    <component :is="hasWebsite ? 'a' : 'div'" :href="formParams.website" target="_blank">
                      <v-img v-if="hasLogo" id="logo" :src="formParams.logo" height="80" contain position="left" />
                    </component>
                  </div>
                </v-col>
                <v-col cols="12" md="8">
                  <v-sheet class="flex-grow-1" max-width="700">
                    <DonationProgress v-if="showObjective" :campaign="campaign" />
                  </v-sheet>
                </v-col>
              </v-row>
              <div>
                <h1 id="form-title" class="display-2">
                  {{ formParams.title }}
                </h1>
                <h2 class="title">
                  {{ formParams.subtitle }}
                </h2>
                <!-- Provient du back -->
                <!-- eslint-disable vue/no-v-html -->
                <p id="content-description" class="text-left body-1 my-4" v-html="formParams.description" />
                <!-- eslint-enable vue/no-v-html -->
              </div>
              <div v-if="expiredCampaign">
                <v-alert text type="error">
                  {{ t("CAMPAGNE_EXPIREE") }}
                </v-alert>
              </div>
              <div v-else>
                <v-row>
                  <v-col md="7" cols="12" class="mx-auto">
                    <slot v-if="dataComplete" />
                  </v-col>
                  <v-col v-if="formParams.content && mode !== 'erreur'" md="5" cols="12" justify-content="center">
                    <!-- Provient du back -->
                    <!-- eslint-disable vue/no-v-html -->
                    <div id="custom-content" v-html="formParams.content" />
                    <!-- eslint-enable vue/no-v-html -->
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </div>
        </div>
      </v-sheet>
    </v-main>
    <layout-footer v-if="dataComplete && formParams.showFooter" />
  </div>
</template>

<script>
import LayoutFooter from "@/components/LayoutFooter"
import DonationProgress from "@/components/DonationProgress"
import LanguageSwapper from "@/components/LanguageSwapper"
import { mapGetters } from "vuex"

export default {
  components: {
    DonationProgress,
    LayoutFooter,
    LanguageSwapper
  },
  metaInfo() {
    return {
      title: this.formParams.title,
      meta: [
        {
          property: "og:title",
          content: this.formParams.title,
          vmid: "og:title"
        },
        {
          property: "og:description",
          content: this.formParams.title,
          vmid: "og:description"
        },
        {
          property: "og:image",
          content: this.formParams.logo,
          vmid: "og:image"
        }
      ]
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    dataLoaded: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    mode: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(["expiredCampaign", "formParams", "campaign", "campaignSlug", "t"]),
    dataComplete() {
      return !this.isLoading && this.dataLoaded
    },
    notFoundData() {
      return !this.isLoading && !this.dataLoaded
    },
    hasLogo() {
      return this.formParams.logo && /jpg|png/.test(this.formParams.logo)
    },
    showObjective() {
      return !!this.campaign && !!this.formParams.publishObjective && this.campaign.objective
    },
    hasWebsite() {
      return this.formParams.website && this.formParams.website.indexOf("http") === 0
    }
  }
}
</script>

<style scoped>
header {
  height: 150px;
  align-items: center;
  display: flex;
}
#content {
  overflow-y: auto;
}
</style>